export default "__VITE_ASSET__BpHscb6a__"